import type { Batch } from '../types';

interface Props {
  batches: Batch[];
  currentId: string | null;
  onSelect: (id: string) => void;
}

export default function BatchTabs({ batches, currentId, onSelect }: Props) {
  return (
    <div className="batch-nav">
      {batches.map((b) => (
        <button
          key={b.id}
          type="button"
          className={'batch-tab' + (b.id === currentId ? ' active' : '')}
          onClick={() => onSelect(b.id)}
        >
          {b.data.metaBatchId || 'Untitled'}
        </button>
      ))}
      <div className="batch-nav-sep" />
    </div>
  );
}
